<div class="footer-wrapper">
  <div class="routes">
    @for (location of locations; track location; let i = $index) {
      <div class="management-column">
        <h5 class="footer-header text-uppercase">{{ location.name }}</h5>
        @for (link of location.links; track link) {
          <div class="footer-link">
            <!-- TODO switch this out for routerLink once all of the -->
            <!--  Admin pages are converted to Angular -->
            <a href="{{link.href}}">{{link.label}}</a>
          </div>
        }
      </div>
    }
  </div>
  <div class="copyright">
    <p>&copy; {{ currentYear }} - AVI Foodsystems, Inc. <em>All Rights Reserved.</em></p>
  </div>
</div>
